import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setName, setRegistered } from '../store/slices/userSlice';
import socket, { sessionId, storage } from '../socket';

export default function Login() {
  const [input, setInput] = useState('');
  const [onlineCount, setOnlineCount] = useState(null);
  const dispatch = useDispatch();

  // Connect early to receive lobby updates (player count)
  useEffect(() => {
    if (!socket.connected) socket.connect();

    const handleLobbyUpdate = (players) => setOnlineCount(players.length);
    socket.on('lobby:update', handleLobbyUpdate);

    return () => { socket.off('lobby:update', handleLobbyUpdate); };
  }, []);

  const handleJoin = (e) => {
    e.preventDefault();
    const name = input.trim();
    if (!name) return;

    storage.setItem('gamePortal_name', name);

    if (socket.connected) {
      // Already connected from the early player-count connection
      socket.emit('register', { name, sessionId });
    } else {
      // The 'connect' handler in App.js will emit register once connected
      socket.connect();
    }

    dispatch(setName(name));
    dispatch(setRegistered({ id: sessionId }));
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>🎮 Game Portal</h1>
        <p className="subtitle">Play Tic-Tac-Toe & Battleship with friends</p>
        <form onSubmit={handleJoin}>
          <input
            className="input-name"
            placeholder="Enter your name..."
            value={input}
            onChange={(e) => setInput(e.target.value)}
            autoFocus
            maxLength={20}
          />
          <button className="btn btn-primary" type="submit" disabled={!input.trim()}>
            Join Lobby{onlineCount !== null ? ` (${onlineCount} online)` : ''}
          </button>
        </form>
      </div>
    </div>
  );
}
